import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import configData from '@/src/config.json';

export type ZopimProps = {
  withIcon?: boolean;
};

export const Zendesk = ({ withIcon }: ZopimProps) => {
  useEffect(() => {
    const hideButtonZendesk = () => {
      if (window.$zopim && !withIcon) {
        window.$zopim.livechat.button.hide();
        clearInterval(interval);
      }
    };

    const interval = setInterval(hideButtonZendesk, 200);
  }, []);

  return (
    <Helmet>
      <script id="ze-snippet" src={configData.ZOPIM} type="text/javascript"></script>
    </Helmet>
  );
};
